// src/components/ui/Toast.tsx
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { hideToast } from 'store/slices/toastSlice';

// Messages are conventionally written as "<emoji> rest of the text" —
// split that leading emoji out so it can be shown as a large icon.
const LEADING_EMOJI = /^(\p{Extended_Pictographic}(?:‍\p{Extended_Pictographic})*)\s*(.*)$/su;

export default function Toast() {
  const dispatch = useDispatch();
  const { message, visible } = useSelector((s: RootState) => s.toast);

  useEffect(() => {
    if (visible) {
      const t = setTimeout(() => dispatch(hideToast()), 4000);
      return () => clearTimeout(t);
    }
  }, [visible, dispatch]);

  const match = message.match(LEADING_EMOJI);
  const icon = match ? match[1] : 'ℹ️';
  const text = match ? match[2] : message;

  return (
    <div className="fixed inset-0 z-[400] flex items-center justify-center pointer-events-none">
      <div className={`bg-[var(--om-panel)] border border-[var(--om-border)] rounded-2xl px-8 py-6 w-[22rem] max-w-[90vw] shadow-2xl text-center transition-all duration-300 ${
        visible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
      }`}>
        <div className="text-4xl mb-2 leading-none">{icon}</div>
        <p className="text-base font-bold text-[var(--om-text)]">{text}</p>
      </div>
    </div>
  );
}
